import { CityFeature } from "@/schemas/city-schema";
import {
	IDailyForecastData,
	IForecastWithStation,
} from "@/types/daily-forecast-type";

export const mergeForecastDataWithStation = (
	stations: CityFeature[],
	forecasts: IDailyForecastData[],
	isArabic: boolean,
): IForecastWithStation[] => {
	const stationMap = new Map(
		stations.map((station) => [station.properties.id, station]),
	);

	if (forecasts.length === 0) {
		return stations.map((station) => {
			return {
				name_ar: station.properties.name_ar,
				name_en: station.properties.name_en,
				station_id: station.properties.id,
				temperature_max: undefined,
				temperature_min: undefined,
				priority: station.properties.Priority,
				ww: undefined,
				date: undefined,
				coordinates: station.geometry.coordinates,
			};
		});
	}

	return forecasts.flatMap((forecast) => {
		const station = stationMap.get(forecast.station_id);

		if (!station) {
			return [];
		}

		return {
			name_ar: station.properties.name_ar,
			name_en: station.properties.name_en,
			station_id: forecast.station_id,
			temperature_max: forecast.temperature_max,
			temperature_min: forecast.temperature_min,
			ww: forecast.ww,
			date: forecast.date,
			coordinates: station.geometry.coordinates,
			priority: station.properties.Priority,
		};
	});
};
